import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

const DeleteConfirmModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  title = "Are you sure?",
  message = "Do you want to delete this item?"
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
      
      <div className="relative flex flex-col w-[30%] bg-white pb-2 p-3 rounded-lg shadow-lg text-left">
        
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-2">
          <h3 className="font-semibold text-lg">{title}</h3>
          <IconButton onClick={onClose}>
            <CloseIcon fontSize="medium" />
          </IconButton>
        </div>

        {/* Message */}
        <h3 className="font-inter my-4 text-lg">
          {message}
        </h3>

        {/* Buttons */}
        <div className="flex justify-between mt-4">
          
          <button
            onClick={onClose}
            className="py-2 px-4 bg-gray-100 rounded-lg text-gray-700 hover:bg-gray-200"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={loading}
            className={`py-2 px-4 ${
              loading ? "bg-gray-400" : "bg-red-600"
            } text-white rounded-lg hover:bg-red-700`}
          >
            {loading ? "Deleting..." : "Yes, Delete"}
          </button>

        </div>

      </div>
    </div>
  );
};

export default DeleteConfirmModal;